
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxRodez = () => {
  return (
    <CityMetauxPage
      cityName="Rodez"
      departmentName="Aveyron"
      departmentCode="12"
      region="Occitanie"
      description="Préfecture de l'Aveyron, Rodez bénéficie de notre expertise dans le rachat de métaux issus du secteur agricole, industriel et de l'artisanat traditionnel aveyronnais."
      specialities={[
        "Métaux agricoles et matériel d'élevage",
        "Équipements industriels et artisanaux",
        "Cuivre et métaux de toiture",
        "Ferraille urbaine et de construction"
      ]}
      nearbyAreas={[
        "Onet-le-Château", "Luc-la-Primaube", "Flavin", "Bozouls", "Espalion", "Villefranche-de-Rouergue"
      ]}
      heroImage="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1280&q=80"
    />
  );
};

export default AchatMetauxRodez;
